import about from '@views/about';

export default {
    path: '/about',
    name: 'about',
    component: about,
};